export const NEW_CHAIN_VALUE = 'newChain';

export const DEFAULT_HISTORY_WINDOW_JSON = '0M7D0:0:0.0';

export const DEFAULT_CHAIN_INDEX = 0;
export const DEFAULT_ENTERPRISE_INDEX = 0;
export const DEFAULT_SERVICE_INDEX = 0;
export const DEFAULT_VISIT_STAY = {
    name: 'Stay',
    enterpriseIndex: DEFAULT_ENTERPRISE_INDEX,
    index: DEFAULT_SERVICE_INDEX,
};

export const ENTERPRISE_BUILDER_JSON_INDENT = 2;

const HASH_DEV =
    '/f8dAB0A/f/9/zAATAf9//3/CAB8AP3/EAAoAP3//f/9//3/cAD9//3/489rAA0A/f/9//3/YwD9/1QA/f8tAP3/MAB/AP3//f9uAP3//f9DAP3/LwD9//3/CwD9//3//f/9/2wA/f8SAP3/dQA3AP3//f8TAA==';
const HASH_DEMO =
    '/f8wACoA/f90AP3//f9HADkAGAD9/1AA/f9zAF8ASgB/ACMA/f8uADEAXwD9//3/vQVFAP3//f8xAGkACABcAP3//f/9//3/ZAAIAGQA/f/9//3//f9ZAP3//f/9/2kAVwD9/yYA/f/9//3/XAD9/3AAKQBFAA=="';
const HASH_PROD =
    '/f/9/2oADgD9//3//f/9/0gAXQA7AHAA/f/9/x0AOAP9//3/AABmAFgAMAAWACQAZwAnAP3//f87AHkCFABsAP3/MQD9/1MALgBjAP3//f9hAP3//f/9/1cA/f9MAFQA/f/9//3/UAD9/0wANQD9/w4ABgA8AP3/PwA=';
const HASH_UNKNOWN =
    'QgAwAB4AMwD9/wYAJABnAv3/OgD9//3/aQD9/yMAAgAjAP3/YgD9/20BegD9//3/HgANAEAAEgD9/zkALwALAFcA/f/9//3/TgATAP3/EAANABAA/f8YAP3//f/9/wsA/f/9//3/FABmAP3/CgD9/ygASgA5AP3/awD9/w==';

// The metadata is used to identify the application / flow (Commander, WebRIA...), and environment in which the JSON import file was created.
export const enterpriseBuilderMetadata = {
    development: HASH_DEV,
    demo: HASH_DEMO,
    production: HASH_PROD,
    unknown: HASH_UNKNOWN,
};
